import { pipe, throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

import { Envelope } from './flume-api.interceptor';
import { AlertUtils } from './alert.utils';

export interface RequestError {
    code: number;
    url?: string;
    message: string;
    error?: any;
}

export class EnvelopeUtils {
    static message(res: Envelope<any>) {
        if (res.detailed) {
            if (typeof res.detailed === 'string') {
                return res.detailed;
            } else if (res.detailed.length) {
                if (typeof res.detailed[0] === 'string') {
                    return (res.detailed as string[]).reduce((a, str) => a + str + '\n', '');
                } else if ((res.detailed[0] as any).message) {
                    return (res.detailed as Array<{ field: string; message: string }>).reduce(
                        (a, obj) => a + obj.message + '\n',
                        ''
                    );
                }
            }
            return JSON.stringify(res.detailed);
        }
        return res.message;
    }

    static handleError() {
        return pipe<Observable<any>, Observable<any>>(
            catchError((error: HttpErrorResponse, caught: any) => {
                let msg = 'Unable to connect, request failed.';
                if (error.error && error.error.http_code) {
                    msg = EnvelopeUtils.message(error.error);
                    AlertUtils.error('Error', msg);
                }

                return throwError({
                    code: error.status,
                    url: error.url,
                    message: msg,
                    error: error.error,
                });
            })
        );
    }
}
